import { EditableText } from "./EditableText";

type TextForDesignProps = {
  onSave?: (value: string) => void;
  value: string;
};

export function TextForDesign({ onSave, value }: TextForDesignProps) {
  return (
    <EditableText
      onSave={onSave}
      placeholder="No text for this design yet"
      value={value}
    />
  );
}
